module.exports = __webpack_public_path__ + "static/media/detailedSubtractGreyhound.faf3e5ad.svg";